import { inject, Injectable } from '@angular/core';
import { ApiClient } from './api-client';
import { Observable } from 'rxjs';
import { SHARED_CONFIG } from '../../../environments/shared-config.token';
import { ApiMetadata } from '../models/ApiMetadata/api-metadata';

@Injectable({
  providedIn: 'root',
})
export class ApiMetadataApi {
  private apiClient = inject(ApiClient);
  private config = inject(SHARED_CONFIG);

  getApiMetadata(): Observable<ApiMetadata> {
    return this.apiClient.get(`${this.config.apiUrl}`);
  }
}
